import type { TOC } from '@ember/component/template-only';
import { htmlSafe } from '@ember/template';

interface AppContentCardSignature {
  Args: {
    bgColorClass?: string;
    title?: string;
    titleClass?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const AppContentCardComponent: TOC<AppContentCardSignature> = <template>
  <div
    class="border border-gray-200 rounded-lg p-4 overflow-hidden
      {{if @bgColorClass @bgColorClass 'bg-tio-gray-50'}}"
    ...attributes
  >
    {{#if @title}}
      <div class="font-semibold mb-3 {{@titleClass}}">
        {{htmlSafe @title}}
      </div>
    {{/if}}

    {{yield}}
  </div>
</template>;

export default AppContentCardComponent;
